import React, { type FC, type HTMLAttributes, type ReactNode } from 'react';

import { cn } from '@/utils/class-name';

export interface ButtonProps extends HTMLAttributes<unknown> {
    theme: 'red' | 'green' | 'blue' | 'orange' | 'outline' | 'press' | 'hidden';
    icon?: 'lead' | 'chevron-up' | 'chevron-down';
    type?: 'button' | 'submit';
    children: ReactNode;
}

export const Button: FC<ButtonProps> = ({ theme, icon, children, className, ...props }) => {
    return (
        <button {...props} className={cn(`button ${theme}-button`, icon && `${icon}-icon`, className)}>
            <span className="button-content">{children}</span>
        </button>
    );
};
